<template>
  <div
    :class="'warp warp-' + elementName"
    v-if="ribbon_can('guideuser') || (hasValidHelpData() && hasActive())"
  >
    <div v-if="isLoading">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else>
      <v-menu
        v-if="ribbon_can('guideuser')"
        v-model="adminmenu"
        max-height="500px"
        class="adminmenuHelpInfo"
        :left="menuDirection === 'left'"
        :right="menuDirection === 'right'"
        :top="adminMenuVertical === 'top'"
        :bottom="adminMenuVertical === 'bottom'"
        :origin="adminMenuVertical === 'top' ? 'top left' : 'bottom left'"
        transition="scale-transition"
        rounded="rounded"
        :offset-x="false"
        :offset-y="true"
        :close-on-content-click="true"
        :nudge-left="menuDirection === 'left' ? adminMenuNudge : 0"
        :nudge-right="menuDirection === 'right' ? adminMenuNudge : 0"
        :nudge-top="adminMenuVertical === 'top' ? adminMenuNudgeVertical : 0"
        :nudge-bottom="
          adminMenuVertical === 'bottom' ? adminMenuNudgeVertical : 0
        "
        :attach="false"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :ref="'adminBtn-' + elementName"
            class="pa-0 ma-0 admin-menu-btn"
            icon
            v-bind="attrs"
            v-on="on"
            :color="buttonColor"
            @click="calculateMenuPosition($event, 'admin')"
            :loading="adminisLoading"
          >
            <v-icon small :color="buttonColor">mdi-information-outline</v-icon>
          </v-btn>
        </template>
        <v-list class="admin-menu-list">
          <v-list-item
            class="admin-menu-item"
            v-for="(item, index) in filteredActions"
            :key="index"
            @click="action(item.title, $event)"
            dense
          >
            <v-list-item-icon class="me-2">
              <v-icon :color="item.color" small>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="d-flex align-center admin-menu-text">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <!-- &&  -->
      <!-- {{ $t('user_menu') }} -->
      <v-container class="pa-0 ma-0">
        <v-menu
          v-model="menu"
          max-height="500"
          min-width="310"
          class="menuHelpInfo"
          :top="userMenuVertical === 'top'"
          :bottom="userMenuVertical === 'bottom'"
          :left="menuDirection === 'left'"
          :right="menuDirection === 'right'"
          :origin="userMenuVertical === 'top' ? 'top left' : 'bottom left'"
          transition="scale-transition"
          rounded="rounded"
          :offset-x="false"
          :offset-y="true"
          :nudge-left="menuDirection === 'left' ? userMenuNudge : 0"
          :nudge-right="menuDirection === 'right' ? userMenuNudge : 0"
          :nudge-top="userMenuVertical === 'top' ? userMenuNudgeVertical : 0"
          :nudge-bottom="
            userMenuVertical === 'bottom' ? userMenuNudgeVertical : 0
          "
          :close-on-content-click="false"
          :attach="false"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-tooltip bottom>
              <template
                v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }"
              >
                <v-btn
                  :ref="'userBtn-' + elementName"
                  class="pa-0 ma-0 user-menu-btn"
                  icon
                  v-bind="{ ...attrs, ...tooltipAttrs }"
                  v-on="{ ...on, ...tooltipOn }"
                  :color="buttonColor"
                  @click="showInfo2($event)"
                  v-if="!ribbon_can('guideuser') && hasValidHelpData()"
                >
                  <v-icon small :color="buttonColor"
                    >mdi-information-outline</v-icon
                  >
                </v-btn>
              </template>
              <span>{{ `${$t("guide_tooltip")} ${item.title || label}` }}</span>
            </v-tooltip>
          </template>
          <v-list class="pt-0">
            <v-list-item
              style="justify-content: space-between"
              class="menu-title pt-2"
            >
              <div class="covertitle">
                <v-list-item-avatar>
                  <v-icon small color="white">mdi-information-outline</v-icon>
                </v-list-item-avatar>
                <v-list-item-title style="font-weight: bold; color: white">{{
                  item.title
                }}</v-list-item-title>
                <v-btn
                  class="ms-2 px-0 text-danger"
                  color="#fcc1c7"
                  depressed
                  min-width="36"
                  :title="$t('close')"
                  @click="menu = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
            </v-list-item>
            <v-divider class="ma-0 pa-0"></v-divider>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>
                  <v-card flat>
                    <v-window
                      transition="slide-x-transition"
                      class="Carousel"
                      v-model="windowIndex"
                      v-if="item?.images || item?.text || item?.videos"
                    >
                      <v-window-item
                        class="CarouselItem"
                        v-if="item?.text || item?.audio"
                      >
                        <div>
                          <media-player
                            v-if="item.audio"
                            ref="menuaudioPlayer"
                            :src="item.audio"
                            :type="'audio/mpeg'"
                            :big="false"
                          ></media-player>
                        </div>
                        <div class="cover">
                          <v-card flat class="text-center"  v-if="item?.text">
                            <v-card-text class="menu-text" style="white-space: pre-wrap; overflow-y: auto; max-height: 150px; text-align: justify; color: rgba(0, 0, 0, 0.87);">
                              {{ item?.text }}
                            </v-card-text>

                          </v-card>
                        </div>
                      </v-window-item>
                      <v-window-item
                        class="CarouselItem"
                        v-if="item?.images && item?.images?.length>0"
                      >
                        <div class="cover">
                          <v-responsive aspect-ratio="16/9" class="mt-0">
                            <v-card
                              v-if="item?.images"
                              class="mt-4 d-flex align-center justify-center"
                            >
                              <img
                                v-if="item?.images?.length === 1"
                                :src="item.images[0].url"
                                :alt="item.images[0].name"
                                style="
                                  align-items: center;
                                  width: 300px;
                                  height: 200px;
                                  object-fit: cover;
                                  cursor: pointer;
                                "
                              />
                              <v-carousel
                                v-else
                                cycle
                                height="200"
                                hide-delimiter-background
                                show-arrows-on-hover
                              >
                                <v-carousel-item
                                  v-for="(image, i) in filteredImages"
                                  :key="i"
                                >
                                  <img
                                    :src="image.url"
                                    :alt="image.name"
                                    style="
                                      align-items: center;
                                      width: 300px;
                                      height: 200px;
                                      object-fit: cover;
                                      cursor: pointer;
                                    "
                                  />
                                </v-carousel-item>
                              </v-carousel>
                            </v-card>
                          </v-responsive>
                        </div>
                      </v-window-item>
                      <v-window-item
                        class="CarouselItem"
                        v-if="item?.videos && item?.videos?.length>0"
                      >
                        <div class="cover">
                          <v-responsive aspect-ratio="16/9" class="mt-0">
                            <v-card
                              class="mt-4 d-flex align-center justify-center flex-column"
                            >
                              <video-iframe
                                  v-if="item && item.videos && item.videos.length > 0"
                                  :key-id="1"
                                  :video="item.videos[0]"
                                  style="
                                    width: 100%;
                                    max-height: 300px;
                                    border-radius: 8px;
                                  "
                                />

                              <!-- <video
                                controls
                                ref="menuVideo"
                                loading="lazy"
                                style="
                                  width: 100%;
                                  max-height: 300px;
                                  border-radius: 8px;
                                "
                                @error="handleVideoError"
                              >
                                <source
                                  :src="item.videos[0].file_link"
                                  type="video/*"
                                />
                                مرورگر شما از هیچ‌یک از فرمت‌های ویدئو پشتیبانی
                                نمی‌کند.
                              </video> -->
                              <v-card-text
                                v-if="videoError"
                                class="text-center"
                                style="color: red"
                                >{{ $t("error_upload_m_video") }}
                              </v-card-text>
                              <v-card-text
                                v-if="item?.videos?.length > 1"
                                class="text-center"
                                style="
                                  background-color: black;
                                  color: white;
                                  border-radius: 8px;
                                "
                                >{{ $t("info_show_video") }}
                              </v-card-text>
                            </v-card>
                          </v-responsive>
                        </div>
                      </v-window-item>
                    </v-window>
                    <v-card-actions class="pa-0 ma-0">
                      <v-row
                        class="mt-0"
                        justify="center"
                        v-if="windowItems?.length > 1"
                      >
                        <v-btn
                          small
                          icon
                          @click="prevWindow"
                          :disabled="windowIndex === 0"
                        >
                          <v-icon>mdi-chevron-right</v-icon>
                        </v-btn>
                        <v-btn
                          small
                          icon
                          @click="nextWindow"
                          :disabled="windowIndex === windowItems.length - 1"
                        >
                          <v-icon>mdi-chevron-left</v-icon>
                        </v-btn>
                      </v-row>
                      <v-spacer class="ma-0 pa-0"></v-spacer>
                      <v-btn
                        color="blue"
                        text
                        @click="showInfo()"
                        :title="$t('more_info')"
                      >
                        {{ $t("more") }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-container>

      <custom-popup
        reloadable
        v-model="addnewGuideDialog"
        :cons="{ title: $t('add_user_guide') }"
        max-width="800"
        hide-confirm
        scrollable
        @input="(val) => (addnewGuideDialog = val)"
        ref="addNewGuidePopup"
      >
        <add-new-user-guide
          :isEdit="false"
          :popupContentRef="
            $refs.addNewGuidePopup?.$el.querySelector('#cp-container')
          "
          :initial-name="elementName || ''"
          @fetch="onFetch"
          @close="closePopup"
          :name="elementName"
          v-model="checkclose"
          :label="label"
          :serviceName="serviceName"
        ></add-new-user-guide>
      </custom-popup>

      <custom-popup
        reloadable
        v-model="editGuideDialog"
        :cons="{ title: $t('edit_user_guide') }"
        max-width="800"
        hide-confirm
        scrollable
        @input="(val) => (editGuideDialog = val)"
      >
        <edit-user-guide
          :guide-id="selectedGuideId"
          @fetch="onFetch"
          @close="closePopup"
          :name="elementName"
          v-model="checkclose"
          :isPopup="true"
        ></edit-user-guide>
      </custom-popup>

      <!-- {{ $t('display_info') }} -->
      <popup-content
        :dialog.sync="dialog"
        :cons="cons"
        :loading.sync="loading"
        :item="item"
        :itemtitle="itemtitle"
      />
    </div>
  </div>
</template>

<script>
import MediaPlayer from "./MediaPlayer.vue";
import { getContentType, GetFile, clearFileCache } from "./GuideContent_axios";
import PopupContent from "./PopupContent.vue";
import EditUserGuide from "./editUserGuide.vue";
import addNewUserGuide from "./addNewUserGuide.vue";
import VideoIframe from "@/view/components/UploadCenter/videoUploader/videoIframe";

export default {
  name: "HelpInfo",
  components: {
    MediaPlayer,
    PopupContent,
    EditUserGuide,
    addNewUserGuide,
    VideoIframe,
  },
  props: {
    elementName: { type: String, required: true },
    serviceName: { type: String, default: null },
    label: { type: String, default: () => "element" },
    helpData: { type: Array, default: () => [] },
  },
  mounted() {
    this.$nextTick(() => {
      this.menuAttach = false; // {{ $t('disable_attach') }}
      this.isReady = true;
    });
    window.addEventListener("resize", this.handleResize);
  },
  data() {
    return {
      isReady: false,
      activeMenuType: null,
      activeButton: null,
      activeRef: null,
      userMenuVertical: "top",
      adminMenuVertical: "bottom",
      userMenuNudgeVertical: 4,
      adminMenuNudgeVertical: 4,
      menuDirection: "left",
      userMenuNudge: 4,
      adminMenuNudge: 4,
      menuAttach: null,
      checkclose: false,
      checker: false,
      editGuideDialog: false,
      addnewGuideDialog: false,
      selectedGuideId: null,
      listAction: [
        { title: this.$t("add"), icon: "mdi-plus", color: "success" },
        { title: this.$t("edit"), icon: "mdi-pencil", color: "warning" },
        { title: this.$t("delete"), icon: "mdi-trash-can", color: "red" },
        { title: this.$t("view"), icon: "mdi-eye", color: "blue" },
      ],
      adminisLoading: false,
      mediaLoading: false,
      maxImages: 4,
      videoError: false,
      cachedData: [],
      offset: false,
      isLoading: false,
      windowIndex: 0,
      cons: { title: this.$t("guide") },
      loading: false,
      menu: false,
      adminmenu: false,
      dialog: false,
      item: {
        title: "",
        text: "",
        images: [],
        videos: [],
        qa: [],
        audio: null,
      },
    };
  },
  computed: {
    itemtitle() {
      const baseTitles = [
        {
          title: this.$t("details"),
          icon: "information-outline",
          color: "blue",
        },
      ];
      if (
        this.item.images &&
        Array.isArray(this.item.images) &&
        this.item.images.length > 2
      ) {
        baseTitles.push({
          title: this.$t("guide_images"),
          icon: "image",
          color: "green",
        });
      }
      if (
        this.item.videos &&
        Array.isArray(this.item.videos) &&
        this.item.videos.length > 2
      ) {
        baseTitles.push({
          title: this.$t("guide_videos"),
          icon: "video",
          color: "green",
        });
      }
      if (
        this.item.qa &&
        Array.isArray(this.item.qa) &&
        this.item.qa.length >= 1
      ) {
        baseTitles.push({
          title: this.$t("faq"),
          icon: "comment-question-outline",
          color: "green",
        });
      }
      return baseTitles;
    },
    filteredActions() {
      if (!this.hasValidHelpData()) {
        return this.listAction.filter(
          (action) => action.title === this.$t("add")
        );
      }
      return this.listAction.filter(
        (action) => action.title !== this.$t("add")
      );
    },
    filteredImages() {
      return this.item.images.slice(0, this.maxImages);
    },
    filteredVideos() {
      return this.item.videos.slice(0, 1);
    },
    windowItems() {
      const items = [];
      if (this.item.text || this.item.audio) items.push("text-audio");
      if (this.item.images && this.item.images.length) items.push("image");
      if (this.item.videos && this.item.videos.length) items.push("video");
      return items;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    menuWidth() {
      return "310px";
    },
    menuHeight() {
      return "500px";
    },
  },
  watch: {
    helpData: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.cachedData = Array.isArray(newVal) ? [...newVal] : [];
        this.buttonColor = this.buttonColorset();
      },
    },
  },
  created() {
    this.cachedData = this.helpData;
    this.buttonColor = this.buttonColorset();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      if (!this.isReady) {
        console.warn("Component not ready in handleResize");
        return;
      }
      if (this.activeButton && this.activeRef && this.$refs[this.activeRef]) {
        const btn = this.$refs[this.activeRef][0] || this.$refs[this.activeRef];
        if (btn && btn instanceof HTMLElement) {
          this.calculateMenuPosition(
            { currentTarget: btn },
            this.activeMenuType
          );
        } else {
          console.warn("Invalid button in handleResize:", btn);
        }
      }
    },
    buttonColorset() {
      if (!this.ribbon_can("guideuser")) return "blue";
      return this.hasValidHelpData() ? "green" : "red";
    },
    hasActive() {
      if (
        !this.cachedData ||
        !Array.isArray(this.cachedData) ||
        this.cachedData.length === 0
      ) {
        return false;
      }
      const itemElement = this.cachedData?.find(
        (p) =>
          p.name &&
          typeof p.name === "string" &&
          p.name.trim() === (this.elementName?.trim() || "")
      );
      return itemElement && itemElement.extras?.isActive === true;
    },
    hasValidHelpData() {
      if (
        !this.cachedData ||
        !Array.isArray(this.cachedData) ||
        this.cachedData.length === 0
      ) {
        return false;
      }
      const itemElement = this.cachedData?.find(
        (p) =>
          p.name &&
          typeof p.name === "string" &&
          p.name.trim() === (this.elementName?.trim() || "")
      );
      return itemElement && itemElement.title && itemElement.title !== "";
    },
    calculateMenuPosition(event, menuType) {
      const btn = event.currentTarget;

      if (!btn || !(btn instanceof HTMLElement)) {
        console.warn("Invalid button element:", btn);
        return;
      }

      this.activeButton = btn;
      this.activeMenuType = menuType;
      this.activeRef = `${menuType === "admin" ? "adminBtn" : "userBtn"}-${
        this.elementName
      }`;

      const btnRect = btn.getBoundingClientRect();
      const menuWidth = menuType === "admin" ? 150 : 310;
      const menuHeight = 500;

      const spaceOnLeft = btnRect.left;
      const spaceOnTop = btnRect.top;
      const spaceOnBottom = window.innerHeight - btnRect.bottom;

      if (spaceOnLeft >= menuWidth) {
        this.menuDirection = "left";
        this.userMenuNudge = 4;
        this.adminMenuNudge = 4;
      } else {
        this.menuDirection = "right";
        this.userMenuNudge = 4;
        this.adminMenuNudge = 4;
      }

      if (menuType === "user") {
        if (spaceOnTop <= menuHeight) {
          this.userMenuVertical = "top";
          this.userMenuNudgeVertical = 4;
        } else {
          this.userMenuVertical = "bottom";
          this.userMenuNudgeVertical = 4;
        }
      } else {
        if (spaceOnBottom <= menuHeight) {
          this.adminMenuVertical = "bottom";
          this.adminMenuNudgeVertical = 4;
        } else {
          this.adminMenuVertical = "top";
          this.adminMenuNudgeVertical = 4;
        }
      }
    },
    closePopup() {
      this.checkclose = true;
      this.addnewGuideDialog = false;
      this.editGuideDialog = false;
    },
    async onFetch() {
      this.isLoading = true;
      this.adminisLoading = true;
      try {
        clearFileCache(this.serviceName); 
        this.$root.$emit("updateData");
        this.$forceUpdate();
      } catch (err) {
        console.error(this.$t("data_preload_error"), err);
        this.cachedData = [];
      } finally {
        this.isLoading = false;
        this.adminmenu = false;
        this.addnewGuideDialog = false;
        this.editGuideDialog = false;
        this.menu = false;
        this.buttonColor = this.buttonColorset();
        this.adminisLoading = false;
        this.$forceUpdate();
      }
    },
    async action(title, event) {
      this.calculateMenuPosition(event, "admin");
      const itemElement = this.cachedData?.find(
        (p) =>
          p.name &&
          typeof p.name === "string" &&
          p.name.trim() === (this.elementName?.trim() || "")
      );
      switch (title) {
        case this.$t("add"):
          this.addnewGuideDialog = true;
          this.editGuideDialog = false;
          this.adminmenu = false;
          break;
        case this.$t("edit"):
          if (itemElement) {
            this.addnewGuideDialog = false;
            this.editGuideDialog = true;
            this.selectedGuideId = itemElement.id;
          } else {
            this.$swal({
              title: this.$t("error"),
              text: this.$t("guide_not_found"),
              icon: "error",
              timer: 3000,
            });
          }
          this.adminmenu = false;
          break;
        case this.$t("delete"):
          await this.remove();
          this.adminmenu = false;
          break;
        case this.$t("view"):
          this.mediaLoading = true;
          if (!this.cachedData || !Array.isArray(this.cachedData)) {
            await this.onFetch();
          }

          if (this.cachedData && this.hasValidHelpData()) {
            const itemElement = this.cachedData?.find(
              (p) => p.name === this.elementName.trim()
            );
            if (!itemElement) {
              this.item = {
                title: "",
                text: "",
                qa: [],
                images: [],
                videos: [],
                audio: null,
              };
              this.dialog = true;
              this.mediaLoading = false;
              return;
            }

            this.item = {
              title: itemElement.title || "",
              text: itemElement.text || "",
              qa: Array.isArray(itemElement.extras?.qa)
                ? itemElement.extras.qa
                : [],
              images: Array.isArray(itemElement.extras?.images?.[0]?.images)
                ? itemElement.extras.images[0].images
                : [],
              videos: Array.isArray(itemElement.extras?.videos?.[0]?.images)
                ? itemElement.extras.videos[0].images
                : [],
              audio: Array.isArray(itemElement.extras?.audio)
                ? itemElement.extras.audio[0] || null
                : itemElement.extras?.audio || null,
            };

            if (itemElement.link) {
              let contentType;
              try {
                contentType = await getContentType(itemElement.link);
              } catch (err) {
                console.error(this.$t("content_type_error"), err);
                contentType = null;
              }

              if (contentType?.startsWith("video/")) {
                this.item.videos = [
                  ...this.item.videos,
                  { file_link: itemElement.link, name: this.$t("video") },
                ];
              } else if (contentType?.startsWith("image/")) {
                this.item.images = [
                  ...this.item.images,
                  { url: itemElement.link, name: this.$t("image") },
                ];
              } else if (contentType?.startsWith("audio/")) {
                this.item.audio = itemElement.link;
              } else {
                console.warn(this.$t("unknown_file_type"), contentType);
              }
            }
            this.dialog = true;
          } else {
            this.isLoading = true;
            this.loading = true;
            GetFile(this.serviceName)
              .then((data) => {
                this.cachedData =
                  Array.isArray(data) && data.length > 0 ? data[0] : [];

                const itemElement = this.cachedData.find(
                  (p) => p.name === this.elementName.trim()
                );
                if (!itemElement) {
                  this.item = {
                    title: "",
                    text: "",
                    qa: [],
                    images: [],
                    videos: [],
                    audio: null,
                  };
                  this.dialog = true;
                  return;
                }

                this.item = {
                  title: itemElement.title || "",
                  text: itemElement.text || "",
                  qa: Array.isArray(itemElement.extras?.qa)
                    ? itemElement.extras.qa
                    : [],
                  images: Array.isArray(itemElement.extras?.images?.[0]?.images)
                    ? itemElement.extras.images[0].images
                    : [],
                  videos: Array.isArray(itemElement.extras?.videos?.[0]?.images)
                    ? itemElement.extras.videos[0].images
                    : [],
                  audio: Array.isArray(itemElement.extras?.audio)
                    ? itemElement.extras.audio[0] || null
                    : itemElement.extras?.audio || null,
                };

                if (itemElement.link) {
                  getContentType(itemElement.link)
                    .then((contentType) => {
                      if (contentType?.startsWith("video/")) {
                        this.item.videos = [
                          ...this.item.videos,
                          {
                            file_link: itemElement.link,
                            name: this.$t("video"),
                          },
                        ];
                      } else if (contentType?.startsWith("image/")) {
                        this.item.images = [
                          ...this.item.images,
                          { url: itemElement.link, name: this.$t("image") },
                        ];
                      } else if (contentType?.startsWith("audio/")) {
                        this.item.audio = itemElement.link;
                      } else {
                        console.warn(this.$t("unknown_file_type"), contentType);
                      }
                    })
                    .catch((err) => {
                      console.error(this.$t("content_type_error"), err);
                    });
                }
              })
              .catch((err) => {
                console.error(this.$t("data_fetch_error"), err);
              })
              .finally(() => {
                this.dialog = true;
                this.loading = false;
                this.isLoading = false;
              });
          }
          this.mediaLoading = false;
          break;
        default:
          console.warn("Unknown action:", title);
          this.adminmenu = false;
      }
      this.adminmenu = false;
    },
    async remove() {
      if (await this.$modal.yesNo(this.$t("delete_guide_question"))) {
        this.adminisLoading = true;
        const item = this.cachedData.find(
          (p) =>
            p.name &&
            typeof p.name === "string" &&
            p.name.trim() === (this.elementName?.trim() || "")
        );
        if (item) {
          try {
            await this.requestApiDeleteCore2(`guideContent/delete/${item.id}`);
            this.$toast.success(this.$t("deleted_successfully"));
            await this.onFetch();
          } catch (response) {
            console.error("failed to delete guide content:", response);
            this.$toast.error(
              response?.data?.message || this.$t("delete_guide_error")
            );
          } finally {
            this.adminisLoading = false;
          }
        }
      }
    },
    handleVideoError() {
      this.videoError = true;
      this.mediaLoading = false;
      this.adminisLoading = false;
    },
    prevWindow() {
      if (this.windowIndex > 0) this.windowIndex--;
    },
    nextWindow() {
      if (this.windowIndex < this.windowItems.length - 1) this.windowIndex++;
    },
    stopMedia(refAudio, refVideo) {
      if (refAudio) {
        const audio = refAudio.$refs.audioPlayer;
        if (audio) {
          audio.pause();
          refAudio.isPlaying = false;
        }
      }
      if (refVideo) {
        refVideo.pause();
      }
    },
    toggleMenu() {
      this.menu = !this.menu;
      if (!this.menu) {
        this.stopMedia(this.$refs.menuaudioPlayer, this.$refs.menuVideo);
      }
      this.adminmenu = false;
    },
    closedialog() {
      this.item = {
        title: "",
        text: "",
        images: [],
        videos: [],
        qa: [],
        audio: null,
      };
      this.dialog = false;
      this.loading = false;
      this.adminisLoading = false;
    },
    showInfo() {
      this.stopMedia(this.$refs.menuaudioPlayer, this.$refs.menuVideo);
      this.menu = false;
      this.dialog = true;
    },
    async showInfo2(event) {
      this.mediaLoading = true;
      this.windowIndex = 0;
      this.calculateMenuPosition(event, "user");

      if (!this.cachedData || !Array.isArray(this.cachedData)) {
        await this.onFetch();
      }

      if (this.cachedData && this.hasValidHelpData()) {
        this.menu = true;
        const itemElement = this.cachedData.find(
          (p) => p.name === this.elementName.trim()
        );
        if (!itemElement) {
          this.item = {
            title: "",
            text: "",
            qa: [],
            images: [],
            videos: [],
            audio: null,
          };
          return;
        }

        this.item = {
          title: itemElement.title || "",
          text: itemElement.text || "",
          qa: itemElement.extras?.qa || [],
          images:
            (itemElement.extras?.images &&
              Array.isArray(itemElement.extras.images) &&
              itemElement.extras.images[0]?.images) ||
            [],
          videos:
            (itemElement.extras?.videos &&
              Array.isArray(itemElement.extras.videos) &&
              itemElement.extras.videos[0]?.images) ||
            [],
          audio: Array.isArray(itemElement.extras?.audio)
            ? itemElement.extras.audio[0] || null
            : itemElement.extras?.audio || null,
        };

        if (itemElement.link) {
          let contentType;
          try {
            contentType = await getContentType(itemElement.link);
          } catch (err) {
            console.error("خطا در دریافت نوع محتوا:", err);
            contentType = null;
          }

          if (contentType?.startsWith("video/")) {
            this.item.videos.push({
              file_link: itemElement.link,
              name: this.$t("video"),
            });
          } else if (contentType?.startsWith("image/")) {
            this.item.images.push({
              url: itemElement.link,
              name: this.$t("image"),
            });
          } else if (contentType?.startsWith("audio/")) {
            this.item.audio = itemElement.link;
          } else {
            console.warn("نوع فایل ناشناخته است:", contentType);
          }
        }
      } else {
        this.isLoading = true;
        this.loading = true;
        GetFile(this.serviceName)
          .then((data) => {
            if (data.length > 0) data = data[0];

            this.cachedData =
              Array.isArray(data) && data.length > 0 ? data[0] : [];

            const itemElement = this.cachedData.find(
              (p) => p.name === this.elementName.trim()
            );
            if (!itemElement) {
              this.item = {
                title: "",
                text: "",
                qa: [],
                images: [],
                videos: [],
                audio: null,
              };
              return;
            }

            this.item = {
              title: itemElement.title || "",
              text: itemElement.text || "",
              qa: itemElement.extras?.qa || [],
              images:
                (itemElement.extras?.images &&
                  Array.isArray(itemElement.extras.images) &&
                  itemElement.extras.images[0]?.images) ||
                [],
              videos:
                (itemElement.extras?.videos &&
                  Array.isArray(itemElement.extras.videos) &&
                  itemElement.extras.videos[0]?.images) ||
                [],
              audio: Array.isArray(itemElement.extras?.audio)
                ? itemElement.extras.audio[0] || null
                : itemElement.extras?.audio || null,
            };

            if (itemElement.link) {
              getContentType(itemElement.link)
                .then((contentType) => {
                  if (contentType?.startsWith("video/")) {
                    this.item.videos.push({
                      file_link: itemElement.link,
                      name: this.$t("video"),
                    });
                  } else if (contentType?.startsWith("image/")) {
                    this.item.images.push({
                      url: itemElement.link,
                      name: this.$t("image"),
                    });
                  } else if (contentType?.startsWith("audio/")) {
                    this.item.audio = itemElement.link;
                  } else {
                    console.warn(this.$t("unknown_file_type"), contentType);
                  }
                })
                .catch((err) => {
                  console.error(this.$t("content_type_error"), err);
                });
            }
          })
          .catch((err) => {
            console.error("خطا در دریافت اطلاعات:", err);
          })
          .finally(() => {
            this.menu = true;
            this.loading = false;
            this.isLoading = false;
          });
      }
      this.mediaLoading = false;
    },
  },
};
</script>

<style scoped>
/* ساختار کلی اطلاعات */
.info {
  display: flex;
  flex-direction: column;
  gap: 1px;
  align-items: center;
  justify-content: center;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 8px;
  direction: rtl;
}

/* منوی کاربر معمولی */
.menuHelpInfo .v-menu__content {
  max-height: 500px !important;
  width: 310px !important;
  z-index: 9999999 !important;
}

/* منوی ادمین */
.adminmenuHelpInfo .v-menu__content {
  max-height: 500px !important;
  width: 150px !important; /* عرض 150 پیکسل برای منوی ادمین */
  min-width: 40px;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  z-index: 99999 !important;
  transition: min-width 0.3s ease-in-out;
}

/* آیتم‌های منوی مدیریت */
.admin-menu-item {
  display: flex;
  align-items: center;
  padding: 4px 8px;
  transition: all 0.3s ease-in-out;
}
.admin-menu-item .v-icon {
  transition: all 0.3s ease-in-out;
}
.admin-menu-list {
  padding: 4px 0;
}

/* ناحیه عکس و عنوان */
.cover {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: 0 5px;
  height: 100%;
}
.covertitle {
  display: flex;
  flex-direction: row;
  width: 100%;
}

/* کاروسل */
.Carousel,
.CarouselItem,
.v-carousel {
  width: 100%;
  height: 200px !important;
  max-height: 200px !important;
  overflow: hidden !important;
  align-items: center;
}

/* دکمه‌ها و عناصر قابل کلیک */
.v-btn,
video,
img {
  pointer-events: auto !important;
}
.interactive-img {
  touch-action: manipulation;
}

/* عنوان منو */
.menu-title {
  background: linear-gradient(to left, #089d88 0%, #03bacf 51%, #514a9d 100%);
  background-size: cover !important;
  word-break: break-word;
}

/* متن منو */
.menu-text {
  max-width: 300px;
  word-break: break-word;
}

.menu:hover,
.menu.active {
  /* background-color: #e3f2fd; */
  transform: scale(1.05);
  transition: all 0.3s ease-in-out;
}

/* نمایشگر بارگذاری */
.loading-wrapper,
.adminloading-wrapper {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
}

.v-list-item__content {
  padding: 0px !important;
}

::v-deep(.v-window__prev),
::v-deep(.v-window__next) {
  margin: 0px !important;
}
* {
  box-sizing: border-box;
}
body {
  font-family: "Vazir", sans-serif;
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
